<div>
    <h2>{{'PP.ABOUT' | translate}} {{ppFileName}}</h2>
    <mat-divider></mat-divider>
    <div style="height: 32rem; overflow-y: auto;">
        <p>{{data.disclaimer}}</p>
    </div>
    <div fxLayout="row wrap" style="justify-content: space-between;">
        <mat-checkbox (change)="onCheckTermsConditions($event)">{{"PP.ACCEPT_TERMS_CONDITIONS" | translate}}</mat-checkbox>
        <div ngStyle.lt-sm="width:100%" align="end">
            <button mat-raised-button class="m-4" color="primary" (click)="onSave()" [disabled]="!termsConditions">
                {{"BUTTONS.SAVE" | translate}}
            </button>
        </div>
    </div>
</div>
